import { useState } from "react";
import LoadingCircle from "../utility/LoadingCircle";

export default function RejectDesignButton({ projectId, tempToken, api, onRejected, validateReject }) {
	const [openModal, setOpenModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [rejecterName, setRejecterName] = useState("");
	const [showValidationModal, setShowValidationModal] = useState(false);
	const [validationMessage, setValidationMessage] = useState("");

	const rejectDesign = async () => {
		setLoading(true);
		if (typeof validateReject === "function") {
			try {
				const result = await validateReject();
				if (!result?.allow) {
					setValidationMessage(
						result?.message || 'Please complete the "Customer Proposed Design Changes" comment before rejecting.'
					);
					setShowValidationModal(true);
					setLoading(false);
					return;
				}
			} catch (error) {
				setValidationMessage("We could not verify required fields. Please try again.");
				setShowValidationModal(true);
				setLoading(false);
				return;
			}
		}
		fetch(api + "/reject-design/" + projectId, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + tempToken,
			},
			body: JSON.stringify({
				rejecterName,
				rejectReason: '',
			}),
		})
			.then((response) => {
				if (!response.ok) {
					if (response.status === 403) {
						alert("You do not have permission to reject this design");
					} else {
						alert("An error occurred while rejecting the design. Please try again.");
					}
					return false;
				}
				return true;
			})
			.then((wasRejected) => {
				if (wasRejected && typeof onRejected === "function") {
					onRejected({
						rejectedBy: rejecterName,
						rejectedReason: "",
						rejectedAt: new Date().toISOString(),
					});
				}
			})
			.finally(() => {
				setLoading(false);
				setOpenModal(false);
				setRejecterName("");
			})
			.catch((error) => {
				console.error("Error rejecting design:", error);
			});
	};

	if (loading && openModal) {
		return (
			<div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 z-[2000] flex justify-center items-center">
				<div className="bg-white text-black p-4 rounded-md shadow-lg flex justify-center items-center flex-col">
					<LoadingCircle />
					<p>Rejecting Design...</p>
				</div>
			</div>
		);
	}

	return (
		<>
			{openModal ? (
				<div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 z-[2000] flex justify-center items-center">
					<div className="bg-white text-black p-4 rounded-md shadow-lg w-full md:w-2/5">
						<div className="flex flex-col justify-between items-center mb-6">
							<p className="text-2xl font-bold">Reject Design</p>
							<p className="text-center mb-4 font-semibold">Please provide your name so we can notify our team.</p>
						</div>
						<div className="my-6">
							<label>Name:</label>
							<input
								type="text"
								value={rejecterName}
								onChange={(e) => setRejecterName(e.target.value)}
								className="border border-black w-full p-1 mt-1"
							/>
						</div>
						<div className="mt-5 flex justify-center gap-2">
							<button onClick={() => setOpenModal(false)} className="bg-gray-500 hover:bg-gray-600 text-white p-2 rounded-md">
								Close
							</button>
							<button
								disabled={!rejecterName}
								onClick={rejectDesign}
								className={`p-2 text-lg text-white rounded-md ${
									!rejecterName ? "bg-gray-500" : "bg-red-600 hover:bg-red-700"
								}`}>
								Reject Design
							</button>
						</div>
					</div>
				</div>
			) : null}
			{showValidationModal ? (
				<div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 z-[2001] flex justify-center items-center">
					<div className="bg-white text-black rounded-lg shadow-xl w-full md:w-2/5">
						<div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
							<p className="text-xl font-bold">Action Required</p>
							<button
								type="button"
								onClick={() => setShowValidationModal(false)}
								className="text-gray-600 hover:text-gray-800 px-2 py-1 rounded-md">
								Close
							</button>
						</div>
						<div className="px-6 py-5">
							<p className="text-base">{validationMessage}</p>
						</div>
						<div className="px-6 pb-5">
							<button
								type="button"
								onClick={() => setShowValidationModal(false)}
								className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md w-full">
								Understood
							</button>
						</div>
					</div>
				</div>
			) : null}
			<div>
				<button onClick={() => setOpenModal(true)} className="p-2 text-lg text-white rounded-md bg-red-600 hover:bg-red-700 w-full">
					Reject design
				</button>
			</div>
		</>
	);
}
